import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { flatten } from 'ramda';

import { getCityNameWithState } from '../utils/format';
import { MetricProp, VisType } from '../constants';
import { getCrimes } from '../selectors/crimes';
import { getMetric, getPrecision } from '../selectors/options';
import { getTotalTimespanInterval } from '../selectors/intervals';
import { timeIntervalPrecisionFormat } from '../utils/format';

import ChartAndLegend from './ChartAndLegend';
import {
  getLegendData,
  barWidth,
  barSpacing,
  setYFromValues,
} from './RecurringChartContainer';
import GenericBarChart, { placeGroupedData } from './GenericBarChart';

export const getRawData = createSelector(
  getLegendData,
  getCrimes,
  getMetric,
  getTotalTimespanInterval,
  (legend, crimes, metric, timespanInterval) =>
    legend.map(({ id, name, state, color }) => ({
      id,
      name,
      state,
      timespanInterval,
      value: crimes[id][0][MetricProp[metric]],
      fill: color,
    })),
);

export const getPlacedData = createSelector(getRawData, data =>
  setYFromValues(flatten(placeGroupedData([data], barWidth, barSpacing, 0))),
);

export const getXTickLabels = createSelector(
  getTotalTimespanInterval,
  getPrecision,
  (interval, precision) => [
    timeIntervalPrecisionFormat[precision](interval).replace(' ', '\n'),
  ],
);

export default connect(state => ({
  chartComponent: GenericBarChart,
  chartData: getPlacedData(state),
  legendData: getLegendData(state),
  resetSelectionOnClick: true,
  xTickLabels: getXTickLabels(state),
  xTickValues: [0],
  showVerticalGrid: false,
  labelAnchor: 'start',
  hoverHPadding: barSpacing / 2,
  onMouseOver: (
    { id, value, timespanInterval, fill, name, state },
    { setHovered },
    [offsetX, offsetY],
  ) => {
    setHovered(id, null, null, {
      timespanInterval,
      x: offsetX,
      y: offsetY,
      visType: VisType.SINGLE,
      mainValue: value,
      sideColor: fill,
      title: getCityNameWithState(name, state),
    });
  },
  onMouseOut: ({ id }, { setHovered }) => {
    setHovered(null, null, id, null);
  },
  onClick: ({ id }, { setSelected }) => {
    setSelected(id);
  },
}))(ChartAndLegend);



// WEBPACK FOOTER //
// ./src/components/SingleIntervalChart.jsx